module.exports = __webpack_public_path__ + "img/add_meeting.d461a91a.svg";